import Vue from 'vue'

const AUTH_URL = 'auth/'
const IS_HOMOLOGATION = process.env.VUE_APP_HOMOLOGATION === 'true'
let refreshPromise = null
let socket = null
let onAuthFailure = null
let interceptorInstalled = false
let authFailureNotified = false
let socketRefreshAttempted = false

function applyAccessToken(token, reconnectSocket) {
  authFailureNotified = false
  sessionStorage.setItem('accessToken', token)
  Vue.http.headers.common.Authorization = `Bearer ${token}`

  if (socket) {
    const wasConnected = socket.connected
    socket.auth = { token }

    if (reconnectSocket && wasConnected) {
      socket.disconnect()
    }
    if (!socket.connected) socket.connect()
  }
}

function clearSession() {
  sessionStorage.clear()
  delete Vue.http.headers.common.Authorization
  if (socket && socket.connected) socket.disconnect()
}

function notifyAuthFailure() {
  if (authFailureNotified) return
  authFailureNotified = true
  clearSession()
  if (typeof onAuthFailure === 'function') onAuthFailure()
}

function exchangeToken(token, profile, reconnectSocket) {
  return Vue.http.post(AUTH_URL, { token, profile }, {
    skipJwtRefresh: true,
    headers: IS_HOMOLOGATION ? { homologation: 'true' } : {}
  }).then(response => {
    const data = response.data || {}
    if (!data.access_token || !data.user) throw new Error('Resposta de autenticação inválida')

    applyAccessToken(data.access_token, reconnectSocket)
    return data
  })
}

function refreshJwt() {
  if (refreshPromise) return refreshPromise

  const token = sessionStorage.getItem('token')
  const profile = sessionStorage.getItem('profile')
  if (!token || !profile) {
    notifyAuthFailure()
    return Promise.reject(new Error('Sessão não renovável'))
  }

  refreshPromise = exchangeToken(token, profile, true)
    .catch(error => {
      notifyAuthFailure()
      throw error
    })
    .finally(() => {
      refreshPromise = null
    })

  return refreshPromise
}

function installHttpInterceptor() {
  if (interceptorInstalled) return
  interceptorInstalled = true

  Vue.http.interceptors.push((request, next) => {
    next(response => {
      if (response.status !== 401 || request.skipJwtRefresh) {
        return response
      }

      if (request.jwtRetried) {
        notifyAuthFailure()
        return response
      }

      request.jwtRetried = true
      return refreshJwt().then(data => {
        request.headers.set('Authorization', `Bearer ${data.access_token}`)
        return Vue.http(request)
      })
    })
  })
}

export default {
  configure(options = {}) {
    socket = options.socket || null
    onAuthFailure = options.onAuthFailure || null
    installHttpInterceptor()

    if (socket) {
      socket.on('connect', () => {
        socketRefreshAttempted = false
      })

      socket.on('connect_error', error => {
        if (error && error.message === 'unauthorized') {
          if (socketRefreshAttempted) {
            notifyAuthFailure()
            return
          }
          socketRefreshAttempted = true
          refreshJwt().catch(() => {})
        }
      })
    }
  },

  authenticate(token, profile) {
    sessionStorage.setItem('token', token)
    sessionStorage.setItem('profile', profile)
    return exchangeToken(token, profile, false)
  },

  refreshJwt,
  clearSession
}
